import React from "react";
import "./Navbar.css";
import {Link} from "react-router";

interface Props {}

function Navbar({}: Props) {
    return <div className="Navbar">
        <div className="Navbar-brand">
            <Link to="/">Wayfare</Link>
        </div>
    </div>
}

export default Navbar;
